<template>
  <div id="IndexSICPO_div">
 <VisorDeDocumentos></VisorDeDocumentos>
    <menusuperior titulo="SICPO" subtitulo="Sistema de control del portal"></menusuperior>
    <menuizquierda></menuizquierda>
    

    <div class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
 
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'
  import VisorDeDocumentos from "@/components/SICPO/Comun/VisorDeArchivos.vue";

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda,
      VisorDeDocumentos
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/SICPO/Comun/Plantilla.vue